import { formatNumberWithSpaces } from "@/composables/formatUtils";

type Translate = (key: string, values?: Record<string, string>) => string;

/**
 * The drift badge: how far a deal's plan is over or under the volume it sold. One sentence per
 * direction, so each language can order it; `driftMwh` is planned minus sold and never 0 here.
 */
export function volumeDriftLabel(t: Translate, driftMwh: number): string {
  return t(
    driftMwh > 0
      ? "forwards.common.deal_badges.volume_over"
      : "forwards.common.deal_badges.volume_under",
    { mwh: formatNumberWithSpaces(Math.abs(driftMwh)) }
  );
}
